@if (options().length) {
  <cdk-virtual-scroll-viewport class="virtual-scroll-viewport" [itemSize]="itemSize()">
    <div class="options">
      <mat-checkbox
        *cdkVirtualFor="let option of options(); trackBy: trackByFn"
        class="filter-option"
        [checked]="selectionModel.isSelected(option.value)"
        (change)="onFilterItemChanges(option.value); onOptionSelect(option, $event.checked)"
      >
        <mp-filter-option [option]="option" [optionLabelTemplate]="optionLabelTemplate()" />
      </mat-checkbox>
    </div>
  </cdk-virtual-scroll-viewport>
} @else {
  <p class="no-options-message">Keine Ergebnisse</p>
}
